import { DialogComponent } from "@theme/dialog";
import { dynamicallyLoadScript } from "@theme/utilities";

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class SearchDialog extends DialogComponent {
  showDialog() {
    // TODO: This could perhaps be improved to show a dialog loading state until
    // `onload` for slower connections, but it's unlikely this would load slower
    // than the time it takes for the user to start searching in most cases.
    dynamicallyLoadScript(window.Theme.assetSources.predictiveSearchJs);
    dynamicallyLoadScript(window.Theme.assetSources.slideshowJs);

    super.showDialog();
  }
}

if (!customElements.get("search-dialog")) {
  customElements.define("search-dialog", SearchDialog);
}
